<template>
    <v-dialog v-model="dialog" width="100%" style="margin: 100px !important;" persistent class="custom-dialog">
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Criar Lista de Embarque
                </span>
            </v-card-title>

            <div style="padding: 20px">

                <v-row no-gutters style="gap: 15px;">
                    <v-text-field :value="selectedItems[0].ordemDeServico?.codigo" class="pt-5 pb-5" type="text"
                        label="OS" chips clearable hide-details outlined disabled></v-text-field>

                    <v-text-field :value="selectedItems[0].ordemDeServico?.jobCodigo" class="pt-5 pb-5" type="text"
                        label="JOB" chips clearable hide-details hide-selected outlined disabled></v-text-field>

                    <v-text-field :value="job?.clienteNome" class="pt-5 pb-5" type="text" label="Cliente" chips
                        clearable hide-details hide-selected outlined disabled></v-text-field>

                </v-row>

                <v-row no-gutters style="gap: 15px;">
                    <v-text-field :value="new Date().toLocaleDateString()" class="pt-5 pb-5" type="text"
                        label="Data da Lista de Embarque" chips clearable hide-details hide-selected outlined
                        disabled></v-text-field>

                    <v-text-field :value="selectedItems.length" class="pt-5 pb-5" type="number" label="Número de Volume"
                        chips clearable hide-details hide-selected outlined :min="0"></v-text-field>

                    <v-text-field v-model="listEmb.pesoLiquido" class="pt-5 pb-5" type="number" label="Peso Liquido"
                        chips clearable hide-details hide-selected outlined :min="0"
                        @change="verifyNumber(listEmb.pesoLiquido, 'pesoLiquido')"></v-text-field>

                    <v-text-field v-model="listEmb.pesoBruto" class="pt-5 pb-5" type="number" label="Peso Bruto" chips
                        clearable hide-details hide-selected outlined :min="0"
                        @change="verifyNumber(listEmb.pesoBruto, 'pesoBruto')"></v-text-field>
                </v-row>

                <v-text-field v-model="listEmb.reponsavel" class="pt-5 pb-5" type="text" label="Responsavel" chips
                    clearable hide-details hide-selected outlined disabled></v-text-field>

                <v-textarea v-model="listEmb.observacao" class="pt-5 pb-5" type="text" label="Observação" chips
                    clearable hide-details hide-selected outlined></v-textarea>

                <v-data-table 
                    :headers="headers" 
                    :items="selectedItems" 
                    item-value="id" 
                    show-expand 
                    disable-sort
                    hide-default-footer 
                    :expanded.sync="expanded"
                >

                    <template v-slot:[`item.quantidadeEntregue`]="{ item, index }">
                        <v-text-field 
                            v-model="item.quantidadeEntregue"
                            type="number"
                            dense
                            @blur="validationQuantity(index)"
                            :min="0"
                        />
                    </template>

                    <template v-slot:[`item.itemCompleto`]="{ item }">
                        <v-checkbox
                            v-model="item.completedItem"
                            @click.stop
                        ></v-checkbox>
                    </template>

                    <!-- Linha expandida -->
                    <template v-slot:expanded-item="{ item }">
                        <td :colspan="10" style="padding: 35px;">
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <td></td>
                                            <th>Sequencia</th>
                                            <th>Subitem</th>
                                            <th>Quantidade Disponivel</th>
                                            <th>Quantidade Entregar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(sub, sIndex) in getSubItems(item)" :key="sIndex">
                                            <td>
                                                <v-checkbox
                                                    :disabled="item.completedItem"
                                                    v-model="selected"
                                                    :value="sub.id"
                                                    @click.stop
                                                ></v-checkbox>
                                            </td>
                                            <td>
                                                {{ sub.seq }}
                                            </td>
                                            <td>{{ sub.description }}</td>
                                            <td>
                                                {{ sub?.qtd || 0 }}
                                            </td>
                                            <td>
                                                <v-text-field 
                                                    :disabled="!selected.includes(sub.id)"
                                                    v-model="sub.qtdEntregue"
                                                    type="number"
                                                    dense
                                                    :min="0"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </td>
                    </template>
                </v-data-table>


                <!-- <v-simple-table dense>
                    <thead>
                        <tr>
                            <th width="5">Squencia</th>
                            <th>Item</th>
                            <th>Quantidade Disponivel</th>
                            <th>Quantidade a entregar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in selectedItems" :key="index">
                            <td class="pa-5" width="5">
                                {{  item.sequencia }}
                            </td>
                            <td>
                                {{ item.descricao }}
                            </td>
                            <td class="pa-5">
                                {{ item.quantidade }}
                            </td>
                            <td class="pa-5" :key="componentKey">
                                <v-text-field 
                                    v-model="item.quantidadeEntregue"
                                    type="number"
                                    dense
                                    @blur="validationQuantity(index)"
                                    :min="0"
                                />
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table> -->
            </div>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="$emit('close')">
                    Cancelar
                </v-btn>

                <v-btn color="blue darken-1" text @click="save">
                    Confirmar
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import EntityService from "@/services/entityService.js";
import Vue from 'vue'

export default {
    name: 'CreateListEmbView',
    props: ['open', 'selectedItems'],
    data(){
        return {
            dialog: false,
            componentKey: 0,
            entityService: new EntityService('Project'),
            job: null,
            expanded: [],
            selected: [],
            selectedItemCompleted: [],
            listEmb: {
                pesoLiquido: 0,
                pesoBruto: 0,
                reponsavel: '',
                observacao: '',
                cliente: '',
            },
            headers: [
                { text: 'Sequência', value: 'sequencia' },
                { text: 'Item', value: 'descricao' },
                { text: 'Qtd Disponível', value: 'quantidade' },
                { text: 'Qtd a Entregar', value: 'quantidadeEntregue' },
                { text: 'Embarcar item por completo', value: 'itemCompleto', width: 200 }
            ],
            idsItemCaldeiraria: [ "9100000", "9500000" ],
            subItemsCaldeiraria: []
        }
    },
    methods: {
        validationQuantity(index){
            if(this.selectedItems[index].quantidadeEntregue < 0){
                this.$notfy.error("Quantidade entrgue invalida.");
                this.selectedItems[index].quantidadeEntregue = 0
                return
            }
            this.selectedItems[index].quantidadeEntregue = Number(this.selectedItems[index].quantidadeEntregue)

            if(this.selectedItems[index].quantidadeEntregue > this.selectedItems[index].quantidade) {
                this.selectedItems[index].quantidadeEntregue = 0
                this.selectedItems[index].status = 'RE'
                this.$notfy.error("Quantidade entrgue invalida.");

                this.componentKey += 1

            } else if (this.selectedItems[index].quantidadeEntregue == this.selectedItems[index].quantidade){
                this.selectedItems[index].status = 'ET'
            } else {
                this.selectedItems[index].status = 'RE'
            }

        },

        verifyNumber(value, field){
            if(value < 0) {
                this.listEmb[field] = 0
                this.$notfy.error("Quantidade invalida.");
            }
        },

        async getJob(){
            const response = await this.entityService.getById(this.selectedItems[0].ordemDeServico?.job)
            this.job = response.data.data
            this.listEmb.cliente = response.data.data.cliente
        },

        async getItemsPav(ordemDeServicoId, itemCodigo){

            const response = await Vue.prototype.$http.get('/Entity/PAV/search-fields', {
                params: {
                    searchFields: 'osItemId',
                    value: ordemDeServicoId,
                    orderBy: 'seq'
                }
            });

            return response.data.data.data
            
        },
        
        getSubItems(item) {
            const found = this.subItemsCaldeiraria?.find(si => si.idSelected === item.id)
            return found?.items || []
        },

        save(){
            //console.log('save >>> ', this.subItemsCaldeiraria, this.selected)
            this.$emit("save", this.selectedItems, this.listEmb, this.subItemsCaldeiraria, this.selected)
        }
    },
    watch: {
        async open(value){
            this.dialog = value;

            if(value){
                let osIds = []
                await this.getJob()
                
                this.selectedItems.map(async (selected) => {
                    osIds.push(selected.id)
                    selected.subItem = []

                    selected.quantidadeEntregue = Number(selected.quantidadeEntregue)

                    if(selected.quantidadeEntregue > selected.quantidade) {
                        selected.quantidadeEntregue = 0
                        selected.status = 'RE'
                        this.$notfy.error("Quantidade entrgue invalida.");
                        
                        this.componentKey += 1

                    } else if (selected.quantidadeEntregue == selected.quantidade){
                        selected.status = 'ET'
                    } else {
                        selected.status = 'RE'
                    }

                    if(this.idsItemCaldeiraria.includes(selected.itemCodigo)){
                         let subItem = await this.getItemsPav(selected.id, selected.itemCodigo)

                        this.subItemsCaldeiraria.push({
                            idSelected: selected.id,
                            items: subItem.filter((itemSub) => itemSub.seq.split('.').length > 1).map((item) => {
                                return {
                                    ...item,
                                    osItemPaiId: selected.id
                                }
                            })
                        })

                    }

                })

                console.log('subItemsCaldeiraria >>> ', this.subItemsCaldeiraria)

            }

            const data = await this.$auth.getUserParams()
            console.log('data', data)
            const responsavel = data?.user

            this.listEmb = {
                pesoLiquido: 0,
                pesoBruto: 0,
                reponsavel: responsavel,
                observacao: '',
                cliente: '',
            }
        },

        async selectedItems(items){
            //console.log('ITEMS >>> ', items)
            //await this.getViewPgp()
        },
    },

    async created(){
        await this.getJob()
    }
}
</script>